import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, watch } from "vue";
import Modal2Component from "@/components/modal/Modal2Component.vue";
import { getStatusSelectOptions } from "@/services/status";
import { showErrorMessage } from "@/services/ui/messages";
import { SubCompanyModel } from "@/services/types/subCompanies";
import { useSubCompaniesStore } from "@/pinia/subcompanies/subcompanies";

interface FormModel {
  name: string;
  status: string;
  ebkId: number;
}

interface Props {
  value: boolean;
  company?: SubCompanyModel;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditSubcompanyFormModal',
  props: {
    value: { type: Boolean },
    company: null
  },
  emits: ["input"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: boolean;
  company?: SubCompanyModel;
}




function emitUpdateValue(newValue: boolean) {
  emit("input", newValue);
}

const isPending = ref(false);
const statusOptions = getStatusSelectOptions();
const formModel = reactive<FormModel>({
  name: "",
  status: "",
  ebkId: null,
});

watch(props, function (props: Props) {
  if (props.value && props.company) {
    formModel.name = props.company.name;
    formModel.status = props.company.status;
    formModel.ebkId = props.company.data?.ebkId ?? null;
  }
});

async function handleSubmit() {
  isPending.value = true;
  try {
    const resp = await useSubCompaniesStore().updateSubCompany({
      id: props.company.id,
      status: formModel.status,
      ...(formModel.name.length && {
        name: formModel.name,
      }),
      data: {
        // ...(formModel.ebkId && { ebkId: formModel.ebkId }),
        ebkId: formModel.ebkId,
      },
    });
    emitUpdateValue(false);
    await useSubCompaniesStore().fetchSubCompanies();
  } catch (e) {
    showErrorMessage(e);
  } finally {
    isPending.value = false;
  }
}

return { __sfc: true,props, emit, emitUpdateValue, isPending, statusOptions, formModel, handleSubmit, Modal2Component }
}

})